import { takeEvery } from "redux-saga/effects";
import actionTypes from "../../actions/actionTypes";
import { createNewWeischerAd } from "./helpers/createItems";


function* addItem({payload}) {
    yield createNewWeischerAd(payload.itemData)
}


export function* watchAddWeischerAd() {
    try {
        yield takeEvery(actionTypes.WEISCHERAD_REQUEST_ADD_ITEM, addItem)
    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}